module.exports = __webpack_public_path__ + "static/title.f4e5b5c4.png";